<template>
	<div class="groupFieldWrapper" :class="{'disabled': !permissions[9]}">
		<div class="groupFieldWrapper_title">
			<span>Repairs</span>
			<button v-if="permissions[9] && workOrderId && !isNewWorkOrders" @click="onSplit" class="splitBtn">
				<svg-sprite width="20" height="20" icon-id="addItem"></svg-sprite>
				<span>Split</span>
			</button>
		</div>
		<div v-for="(item, idx) in times" :key="idx" class="groupField_wrap">
			<field
					:class-error="getError(idx, 'box_id') || item.isErrorTime"
					margin="0 10px 10px 0"
					width="203px"
					label="BOX #"
					:idx="idx"
					placeholder="Select option"
					@updateAutocomplete="onAutocomplete($event, 'box_id')"
					:autocompleteValue="item.box_id"
					:items="boxes"
					:isClearable="false"
					is-autocomplete
					:is-required="isDirty || isLightWorkOrder"
			></field>
			<field
					:class-error="getError(idx, 'start_repair') || item.isErrorTime"
					margin="0 10px 10px 0"
					width="203px"
					type="text"
					label="Start date"
					placeholder="MM/DD/YYYY"
					display-format="YYYY-MM-DD hh:mm"
					:dateValue="item.start_repair"
					@updateTime="onDate($event, idx, 'start_repair')"
					is-time
					:is-required="isDirty || isLightWorkOrder"
			></field>
			<field
					:class-error="getError(idx, 'end_repair') || item.isErrorTime"
					margin="0 10px 10px 0"
					width="203px"
					type="text"
					label="End date"
					placeholder="MM/DD/YYYY"
					display-format="YYYY-MM-DD hh:mm"
					:dateValue="item.end_repair"
					@updateTime="onDate($event, idx, 'end_repair')"
					is-time
					is-right
					:is-required="isDirty || isLightWorkOrder"
			></field>
			<button @click="onDeleteItem(idx)" :disabled="times.length === 1">
				<svg-sprite :style="`color: ${getColorIcon}`" width="20" height="20" icon-id="deleteItem"></svg-sprite>
			</button>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
	name: "SplitRepairs",
	props: {
		isNewWorkOrders: Boolean,
		workOrderId: Boolean,
		isLightWorkOrder: Boolean,
		boxes: Array,
		vl: Object,
		isDirty: Boolean,
		times: Array,
		permissions: Object,
		isDelItem: Boolean
	},
	computed: {
		getColorIcon() {
			if (this.permissions[9]) {
				return this.times.length > 1 ? '#19BC38' : '#8F90A6';
			}

			return '#8F90A6';
		}
	},
	data: () => ({
		isChangedDate: true
	}),
	methods: {
		onAutocomplete({ value, idx }, key) {
			this.$emit('updateSplitRepairs', { value, idx, key });
		},
		getError(idx, key) {
			return this.vl.times?.$each?.$iter[idx][key].$error;
		},
		onDate(date, idx, key) {
			this.$emit('updateSplitRepairs', { value: date, idx, key });
			this.times[idx][key] = date;
		},
		onSplit() {
			const value = {
				box_id: null,
				start_repair: null,
				end_repair: null,
			};

			if (this.times.length === 1 && this.isChangedDate) {
				const timeNow = moment().format('YYYY-MM-DD HH:mm');
				value['start_repair'] = moment(timeNow).add(4, 'hour').format('YYYY-MM-DD HH:mm');
				this.$set(this.times[0], 'end_repair', timeNow);
				this.isChangedDate = false;
			}
			this.times.push(value);
		},
		onDeleteItem(idx) {
			this.times.splice(idx, 1);
		}
	}
};
</script>

<style scoped lang="scss">
@import "SplitRepairs";
</style>
